import type Immutable from 'immutable'
import { createSelector } from 'reselect'

import { actionTypes } from 'actions/actionTypes'
import { getCategoriesFromProducts } from 'utils/products'

type ImmutableProduct = Immutable.Map<string, any>
type ImmutableCategory = Immutable.Map<string, any>

export type RootState = {
  products: Immutable.Map<string, ImmutableProduct>
  productsCategories: Immutable.Map<string, ImmutableCategory>
  productsStock: Immutable.Map<string, any>
  error: Immutable.Map<string, any>
}

export const getProducts = (state: RootState) => state.products

export const getProductsCategories = (state: RootState) => state.productsCategories

export const getProductsStock = (state: RootState) => state.productsStock

export const getProductsLoadError = (state: RootState) =>
  Boolean(state.error.get(actionTypes.PRODUCTS_RECEIVE, null))

export const getProductsStockLoadError = (state: RootState) =>
  Boolean(state.error.get(actionTypes.PRODUCTS_STOCK_RECEIVE, null))

const getResolvedProducts = createSelector(
  [getProducts, getProductsStock],
  (products, productsStock) =>
    products.map((product) => {
      const resolvedStock = product?.get('stock') ?? productsStock.get(product?.get('id'))

      return resolvedStock === undefined ? product : product?.set('stock', resolvedStock)
    }),
)

export const getCategoriesForNavBar = createSelector(
  getProducts,
  getProductsCategories,
  (products, productsCategories) => getCategoriesFromProducts(products, productsCategories),
)

export const getProductsInStock = createSelector(getResolvedProducts, (products) =>
  products.filter((product) => product?.get('stock') > 0),
)

export const getProductsOutOfStock = createSelector(getResolvedProducts, (products) =>
  products.filter((product) => product?.get('stock') <= 0),
)

export const getProductsForMarket = createSelector(
  [getProductsInStock, getProductsOutOfStock],
  (inStockProducts, outOfStockProducts) => inStockProducts.concat(outOfStockProducts).toJS(),
)
